import { useMutation } from "@tanstack/react-query";
import smsTemplateService from "..";

function useRemoveTemplate() {
  return useMutation({
    mutationFn: smsTemplateService.removeSmsTemplate,
  });
}

export default useRemoveTemplate;
